module.exports = __webpack_public_path__ + "static/media/report-dark.eb5ed2b5.svg";